import { Component, OnDestroy, ChangeDetectionStrategy, inject } from '@angular/core';
import { AppBreadcrumbService } from './app.breadcrumb.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppBreadcrumbComponent implements OnDestroy {
    breadcrumbService = inject(AppBreadcrumbService);


    subscription: Subscription;

    items: MenuItem[];

    constructor() {
        const breadcrumbService = this.breadcrumbService;

        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
